import dayjs from 'dayjs';
import { API_ENDPOINTS } from '@/config/api';

interface StatsResponse {
  total: number;
  onSite: number;
  online: number;
  lastRefreshDate: string;
}

export const useStats = () => {
  const { fetchWithAuth } = useApiConfig();
  const result = useAsyncData<StatsResponse>('stats', () =>
    fetchWithAuth<StatsResponse>(API_ENDPOINTS.STATS),
  );

  const lastRefreshRelative = computed(() =>
    result.data.value?.lastRefreshDate
      ? dayjs(result.data.value.lastRefreshDate).fromNow()
      : null,
  );

  return { ...result, lastRefreshRelative };
};
